// libs
import styled from 'styled-components'
// views
import { ButtonsWrapper, darkCellCSS, darkTextAreaCSS } from '../../views'

const TopRowsContainer = styled.div<{ appetiteEnabled: boolean; multiplier: number }>`
  display: flex;
  margin-left: ${({ appetiteEnabled, multiplier }) => {
    const baseMargin = appetiteEnabled ? 74 : 278

    return `${baseMargin + +multiplier * 204}px`
  }};

  ${ButtonsWrapper} {
    display: flex;
    position: absolute;
    bottom: -30px;
    left: ${({ appetiteEnabled }) => (appetiteEnabled ? 202 : 0)}px;
  }
`

const TopRowsWrapper = styled.div`
  width: 100%;
  gap: 4px;
  display: flex;
  flex-direction: column;
  position: relative;
`

const TopRow = styled.div`
  display: flex;
  width: 100%;
  gap: 4px;

  > div:first-child {
    ${darkCellCSS};
    ${darkTextAreaCSS};
  }
`

const TopRowContainer = styled.div`
  display: flex;
  gap: 4px;
`

export { TopRowsContainer, TopRowsWrapper, TopRowContainer, TopRow }
